/** A single visual rhythm for all listing and experience section headings. */
export default function SectionHead({ title, subtitle = null, action = null }) {
  return (
    <div className="mb-3 flex min-w-0 items-end justify-between gap-3 border-b border-[#d7d3cb] pb-3 dark:border-white/20 sm:mb-4 sm:pb-4">
      <div className="min-w-0 flex-1">
        <h2 className="yts-edit-title text-[clamp(24px,4.5vw,39px)] font-extrabold leading-[1.025] tracking-[-.04em] text-[#171719] dark:text-[#F5F3EF]">
          {title}
        </h2>
        {subtitle && (
          <p className="yts-edit-deck mt-1.5 line-clamp-1 max-w-[65ch] text-[11.5px] leading-[1.5] text-[#6f6a62] dark:text-[#BDB8B3] sm:line-clamp-2 sm:text-[13px]">
            {subtitle}
          </p>
        )}
      </div>
      {action && <div className="flex shrink-0 items-center pb-0.5">{action}</div>}
    </div>
  );
}
